/**
 * Letter mark used when Google or Outlook sent no picture.
 * The top bar and campaign faces both call this, so the same person
 * gets the same letters and the same color in both places.
 */

const COLORS = [
  '#0F4D3F',
  '#1D4ED8',
  '#0F766E',
  '#6D28D9',
  '#9D174D',
  '#B45309',
  '#0369A1',
  '#4338CA',
] as const;

export function personInitials(input: {
  firstName?: string | null;
  lastName?: string | null;
  name?: string | null;
  email?: string | null;
}): string {
  const first = (input.firstName || '').trim();
  const last = (input.lastName || '').trim();
  if (first && last) return `${first[0]}${last[0]}`.toUpperCase();

  const raw = (input.name || '').trim();
  const name = raw.includes('@') ? raw.split('@')[0] : raw;
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  if (parts.length === 1 && parts[0][0]) return parts[0][0].toUpperCase();
  if (first[0]) return first[0].toUpperCase();
  if (last[0]) return last[0].toUpperCase();

  const email = (input.email || '').trim();
  return email ? email[0].toUpperCase() : '';
}

/** Stable color for a person. Same seed always lands on the same swatch. */
export function avatarColor(seed: string): string {
  const key = seed.trim().toLowerCase();
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return COLORS[hash % COLORS.length];
}
